module.exports = __webpack_public_path__ + "static/media/signage-indoor-img65.2274ff2a.jpg";